export default {
    mobile: /^[1][3,4,5,6,7,8,9][0-9]{9}$/      // 手机号正则验证
}